import React from 'react'

const Form = ({ onSubmit, disabled, ...props }) => {
  const handleSubmit = e => {
    e.preventDefault()
    !disabled && onSubmit(e)
  }
  return <form style={{ width: '100%' }} onSubmit={handleSubmit} {...props} />
}

export default Form
